// extracted by mini-css-extract-plugin
export default {"descriptionText":"description__descriptionText___Cx8Bb","descriptionHeader":"description__descriptionHeader___muyu6"};